export interface EnvironmentSettings {
  /** The base url for api */
  apiBaseUrl: string;

  /** The source org code for default settings */
  defaultOrgCode: string;
  /** The base url for logos. */
  logosBaseUrl: string;
  /** Is this production mode. */
  production: boolean;
  /** The base url for social logos. */
  socialLogosBaseUrl: string;
  taglineUrl: string;
  anniversaryUrl: string;
  floridaTrendUrl: string;
  joinourteamUrl: string;
  msrealestateUrl: string;
  oraSealUrl: string;
  bestPlacesToWorkUrl: string;
  apiConfig: {
    scopes: string[];
    uri: string;
  };
    msalConfig: {
    auth: {
      clientId: string;
      authority: string;
    };
  };
}

/** Base environment settings that can be overriden by environments.*/
export const environmentBase = {
  defaultOrgCode: '',
  logosBaseUrl: '',
  socialLogosBaseUrl: '',
  taglineUrl: '',
  anniversaryUrl: '',
  floridaTrendUrl: '',
  joinourteamUrl: '',
  msrealestateUrl: '',
  oraSealUrl: '',
  bestPlacesToWorkUrl: ''
};

//* dfb please keep for a minute to ensure it all works */

// /** Base environment settings that can be overriden by environments.*/
// export const environmentBase = {
//   defaultOrgCode: 'tcc',
//   logosBaseUrl: '/assets/logos',
//   socialLogosBaseUrl: '/assets/social',
//   taglineUrl: '/assets/tagline.jpg',
//   anniversaryUrl: '/assets/50yearsplus.png',
//   floridaTrendUrl: '/assets/floridatrend.png',
//   msrealestateUrl: '/assets/msrealestate.png',
//   oraSealUrl: '/assets/oraseal.png',
//   bestPlacesToWorkUrl: '/assets/Best-Places-to-work-Logo.png'
// };